import { getCurrentCurrency } from "@/utils/countryConfigUtils";
import { useEffect, useState } from "react";

/**
 * 获取当前国家的货币代码
 * @returns 货币代码，如 XOF, GHS, NGN 等
 */
export const useCurrency = (): string => {
  const [currency, setCurrency] = useState<string>(getCurrentCurrency());
  
  useEffect(() => {
    // 支持运行时货币切换（如果需要）
    setCurrency(getCurrentCurrency());
  }, []);
  
  return currency;
};

